import { showMicrophoneRationaleIfNeeded } from './microphoneRationale';
import {
  ensureWebViewMediaPermissions,
  hasWebViewMediaPermissions,
  isWebViewMode
} from './webviewBridge';

type WebViewMediaPermissionParams = {
  audio: boolean;
  video: boolean;
};

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => window.setTimeout(resolve, ms));
}

function getRequiredPermissionMessage(params: WebViewMediaPermissionParams): string {
  if (params.audio && params.video) {
    return 'camera/microphone permission is required. Grant access and try again.';
  }
  if (params.video) {
    return 'camera permission is required. Grant access and try again.';
  }
  return 'microphone permission is required. Grant access and try again.';
}

async function waitForWebViewMediaPermissions(params: WebViewMediaPermissionParams): Promise<void> {
  const startedAt = Date.now();
  const timeoutMs = 30_000;

  while (Date.now() - startedAt < timeoutMs) {
    if (hasWebViewMediaPermissions(params)) return;
    await delay(250);
  }

  throw new Error(getRequiredPermissionMessage(params));
}

export async function requestWebViewMediaPermissions(params: WebViewMediaPermissionParams): Promise<void> {
  if (!isWebViewMode) return;
  if (!params.audio && !params.video) return;
  if (hasWebViewMediaPermissions(params)) return;

  if (params.audio) {
    await showMicrophoneRationaleIfNeeded();
  }

  try {
    ensureWebViewMediaPermissions(params);
  } catch (error) {
    const message = error instanceof Error ? error.message : '';
    if (!/permission is required/i.test(message)) throw error;
  }

  await waitForWebViewMediaPermissions(params);
}
